var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../common/temp/node_modules/.pnpm/i18n-iso-countries@7.14.0/node_modules/i18n-iso-countries/codes.json
var require_codes = __commonJS({
  "../../common/temp/node_modules/.pnpm/i18n-iso-countries@7.14.0/node_modules/i18n-iso-countries/codes.json"(exports, module) {
    module.exports = [
      ["AF", "AFG", "004", "ISO 3166-2:AF"],
      ["AL", "ALB", "008", "ISO 3166-2:AL"],
      ["DZ", "DZA", "012", "ISO 3166-2:DZ"],
      ["AS", "ASM", "016", "ISO 3166-2:AS"],
      ["AD", "AND", "020", "ISO 3166-2:AD"],
      ["AO", "AGO", "024", "ISO 3166-2:AO"],
      ["AI", "AIA", "660", "ISO 3166-2:AI"],
      ["AQ", "ATA", "010", "ISO 3166-2:AQ"],
      ["AG", "ATG", "028", "ISO 3166-2:AG"],
      ["AR", "ARG", "032", "ISO 3166-2:AR"],
      ["AM", "ARM", "051", "ISO 3166-2:AM"],
      ["AW", "ABW", "533", "ISO 3166-2:AW"],
      ["AU", "AUS", "036", "ISO 3166-2:AU"],
      ["AT", "AUT", "040", "ISO 3166-2:AT"],
      ["AZ", "AZE", "031", "ISO 3166-2:AZ"],
      ["BS", "BHS", "044", "ISO 3166-2:BS"],
      ["BH", "BHR", "048", "ISO 3166-2:BH"],
      ["BD", "BGD", "050", "ISO 3166-2:BD"],
      ["BB", "BRB", "052", "ISO 3166-2:BB"],
      ["BY", "BLR", "112", "ISO 3166-2:BY"],
      ["BE", "BEL", "056", "ISO 3166-2:BE"],
      ["BZ", "BLZ", "084", "ISO 3166-2:BZ"],
      ["BJ", "BEN", "204", "ISO 3166-2:BJ"],
      ["BM", "BMU", "060", "ISO 3166-2:BM"],
      ["BT", "BTN", "064", "ISO 3166-2:BT"],
      ["BO", "BOL", "068", "ISO 3166-2:BO"],
      ["BA", "BIH", "070", "ISO 3166-2:BA"],
      ["BW", "BWA", "072", "ISO 3166-2:BW"],
      ["BV", "BVT", "074", "ISO 3166-2:BV"],
      ["BR", "BRA", "076", "ISO 3166-2:BR"],
      ["IO", "IOT", "086", "ISO 3166-2:IO"],
      ["BN", "BRN", "096", "ISO 3166-2:BN"],
      ["BG", "BGR", "100", "ISO 3166-2:BG"],
      ["BF", "BFA", "854", "ISO 3166-2:BF"],
      ["BI", "BDI", "108", "ISO 3166-2:BI"],
      ["KH", "KHM", "116", "ISO 3166-2:KH"],
      ["CM", "CMR", "120", "ISO 3166-2:CM"],
      ["CA", "CAN", "124", "ISO 3166-2:CA"],
      ["CV", "CPV", "132", "ISO 3166-2:CV"],
      ["KY", "CYM", "136", "ISO 3166-2:KY"],
      ["CF", "CAF", "140", "ISO 3166-2:CF"],
      ["TD", "TCD", "148", "ISO 3166-2:TD"],
      ["CL", "CHL", "152", "ISO 3166-2:CL"],
      ["CN", "CHN", "156", "ISO 3166-2:CN"],
      ["CX", "CXR", "162", "ISO 3166-2:CX"],
      ["CC", "CCK", "166", "ISO 3166-2:CC"],
      ["CO", "COL", "170", "ISO 3166-2:CO"],
      ["KM", "COM", "174", "ISO 3166-2:KM"],
      ["CG", "COG", "178", "ISO 3166-2:CG"],
      ["CD", "COD", "180", "ISO 3166-2:CD"],
      ["CK", "COK", "184", "ISO 3166-2:CK"],
      ["CR", "CRI", "188", "ISO 3166-2:CR"],
      ["CI", "CIV", "384", "ISO 3166-2:CI"],
      ["HR", "HRV", "191", "ISO 3166-2:HR"],
      ["CU", "CUB", "192", "ISO 3166-2:CU"],
      ["CY", "CYP", "196", "ISO 3166-2:CY"],
      ["CZ", "CZE", "203", "ISO 3166-2:CZ"],
      ["DK", "DNK", "208", "ISO 3166-2:DK"],
      ["DJ", "DJI", "262", "ISO 3166-2:DJ"],
      ["DM", "DMA", "212", "ISO 3166-2:DM"],
      ["DO", "DOM", "214", "ISO 3166-2:DO"],
      ["EC", "ECU", "218", "ISO 3166-2:EC"],
      ["EG", "EGY", "818", "ISO 3166-2:EG"],
      ["SV", "SLV", "222", "ISO 3166-2:SV"],
      ["GQ", "GNQ", "226", "ISO 3166-2:GQ"],
      ["ER", "ERI", "232", "ISO 3166-2:ER"],
      ["EE", "EST", "233", "ISO 3166-2:EE"],
      ["ET", "ETH", "231", "ISO 3166-2:ET"],
      ["FK", "FLK", "238", "ISO 3166-2:FK"],
      ["FO", "FRO", "234", "ISO 3166-2:FO"],
      ["FJ", "FJI", "242", "ISO 3166-2:FJ"],
      ["FI", "FIN", "246", "ISO 3166-2:FI"],
      ["FR", "FRA", "250", "ISO 3166-2:FR"],
      ["GF", "GUF", "254", "ISO 3166-2:GF"],
      ["PF", "PYF", "258", "ISO 3166-2:PF"],
      ["TF", "ATF", "260", "ISO 3166-2:TF"],
      ["GA", "GAB", "266", "ISO 3166-2:GA"],
      ["GM", "GMB", "270", "ISO 3166-2:GM"],
      ["GE", "GEO", "268", "ISO 3166-2:GE"],
      ["DE", "DEU", "276", "ISO 3166-2:DE"],
      ["GH", "GHA", "288", "ISO 3166-2:GH"],
      ["GI", "GIB", "292", "ISO 3166-2:GI"],
      ["GR", "GRC", "300", "ISO 3166-2:GR"],
      ["GL", "GRL", "304", "ISO 3166-2:GL"],
      ["GD", "GRD", "308", "ISO 3166-2:GD"],
      ["GP", "GLP", "312", "ISO 3166-2:GP"],
      ["GU", "GUM", "316", "ISO 3166-2:GU"],
      ["GT", "GTM", "320", "ISO 3166-2:GT"],
      ["GN", "GIN", "324", "ISO 3166-2:GN"],
      ["GW", "GNB", "624", "ISO 3166-2:GW"],
      ["GY", "GUY", "328", "ISO 3166-2:GY"],
      ["HT", "HTI", "332", "ISO 3166-2:HT"],
      ["HM", "HMD", "334", "ISO 3166-2:HM"],
      ["VA", "VAT", "336", "ISO 3166-2:VA"],
      ["HN", "HND", "340", "ISO 3166-2:HN"],
      ["HK", "HKG", "344", "ISO 3166-2:HK"],
      ["HU", "HUN", "348", "ISO 3166-2:HU"],
      ["IS", "ISL", "352", "ISO 3166-2:IS"],
      ["IN", "IND", "356", "ISO 3166-2:IN"],
      ["ID", "IDN", "360", "ISO 3166-2:ID"],
      ["IR", "IRN", "364", "ISO 3166-2:IR"],
      ["IQ", "IRQ", "368", "ISO 3166-2:IQ"],
      ["IE", "IRL", "372", "ISO 3166-2:IE"],
      ["IL", "ISR", "376", "ISO 3166-2:IL"],
      ["IT", "ITA", "380", "ISO 3166-2:IT"],
      ["JM", "JAM", "388", "ISO 3166-2:JM"],
      ["JP", "JPN", "392", "ISO 3166-2:JP"],
      ["JO", "JOR", "400", "ISO 3166-2:JO"],
      ["KZ", "KAZ", "398", "ISO 3166-2:KZ"],
      ["KE", "KEN", "404", "ISO 3166-2:KE"],
      ["KI", "KIR", "296", "ISO 3166-2:KI"],
      ["KP", "PRK", "408", "ISO 3166-2:KP"],
      ["KR", "KOR", "410", "ISO 3166-2:KR"],
      ["KW", "KWT", "414", "ISO 3166-2:KW"],
      ["KG", "KGZ", "417", "ISO 3166-2:KG"],
      ["LA", "LAO", "418", "ISO 3166-2:LA"],
      ["LV", "LVA", "428", "ISO 3166-2:LV"],
      ["LB", "LBN", "422", "ISO 3166-2:LB"],
      ["LS", "LSO", "426", "ISO 3166-2:LS"],
      ["LR", "LBR", "430", "ISO 3166-2:LR"],
      ["LY", "LBY", "434", "ISO 3166-2:LY"],
      ["LI", "LIE", "438", "ISO 3166-2:LI"],
      ["LT", "LTU", "440", "ISO 3166-2:LT"],
      ["LU", "LUX", "442", "ISO 3166-2:LU"],
      ["MO", "MAC", "446", "ISO 3166-2:MO"],
      ["MG", "MDG", "450", "ISO 3166-2:MG"],
      ["MW", "MWI", "454", "ISO 3166-2:MW"],
      ["MY", "MYS", "458", "ISO 3166-2:MY"],
      ["MV", "MDV", "462", "ISO 3166-2:MV"],
      ["ML", "MLI", "466", "ISO 3166-2:ML"],
      ["MT", "MLT", "470", "ISO 3166-2:MT"],
      ["MH", "MHL", "584", "ISO 3166-2:MH"],
      ["MQ", "MTQ", "474", "ISO 3166-2:MQ"],
      ["MR", "MRT", "478", "ISO 3166-2:MR"],
      ["MU", "MUS", "480", "ISO 3166-2:MU"],
      ["YT", "MYT", "175", "ISO 3166-2:YT"],
      ["MX", "MEX", "484", "ISO 3166-2:MX"],
      ["FM", "FSM", "583", "ISO 3166-2:FM"],
      ["MD", "MDA", "498", "ISO 3166-2:MD"],
      ["MC", "MCO", "492", "ISO 3166-2:MC"],
      ["MN", "MNG", "496", "ISO 3166-2:MN"],
      ["MS", "MSR", "500", "ISO 3166-2:MS"],
      ["MA", "MAR", "504", "ISO 3166-2:MA"],
      ["MZ", "MOZ", "508", "ISO 3166-2:MZ"],
      ["MM", "MMR", "104", "ISO 3166-2:MM"],
      ["NA", "NAM", "516", "ISO 3166-2:NA"],
      ["NR", "NRU", "520", "ISO 3166-2:NR"],
      ["NP", "NPL", "524", "ISO 3166-2:NP"],
      ["NL", "NLD", "528", "ISO 3166-2:NL"],
      ["NC", "NCL", "540", "ISO 3166-2:NC"],
      ["NZ", "NZL", "554", "ISO 3166-2:NZ"],
      ["NI", "NIC", "558", "ISO 3166-2:NI"],
      ["NE", "NER", "562", "ISO 3166-2:NE"],
      ["NG", "NGA", "566", "ISO 3166-2:NG"],
      ["NU", "NIU", "570", "ISO 3166-2:NU"],
      ["NF", "NFK", "574", "ISO 3166-2:NF"],
      ["MP", "MNP", "580", "ISO 3166-2:MP"],
      ["MK", "MKD", "807", "ISO 3166-2:MK"],
      ["NO", "NOR", "578", "ISO 3166-2:NO"],
      ["OM", "OMN", "512", "ISO 3166-2:OM"],
      ["PK", "PAK", "586", "ISO 3166-2:PK"],
      ["PW", "PLW", "585", "ISO 3166-2:PW"],
      ["PS", "PSE", "275", "ISO 3166-2:PS"],
      ["PA", "PAN", "591", "ISO 3166-2:PA"],
      ["PG", "PNG", "598", "ISO 3166-2:PG"],
      ["PY", "PRY", "600", "ISO 3166-2:PY"],
      ["PE", "PER", "604", "ISO 3166-2:PE"],
      ["PH", "PHL", "608", "ISO 3166-2:PH"],
      ["PN", "PCN", "612", "ISO 3166-2:PN"],
      ["PL", "POL", "616", "ISO 3166-2:PL"],
      ["PT", "PRT", "620", "ISO 3166-2:PT"],
      ["PR", "PRI", "630", "ISO 3166-2:PR"],
      ["QA", "QAT", "634", "ISO 3166-2:QA"],
      ["RE", "REU", "638", "ISO 3166-2:RE"],
      ["RO", "ROU", "642", "ISO 3166-2:RO"],
      ["RU", "RUS", "643", "ISO 3166-2:RU"],
      ["RW", "RWA", "646", "ISO 3166-2:RW"],
      ["SH", "SHN", "654", "ISO 3166-2:SH"],
      ["KN", "KNA", "659", "ISO 3166-2:KN"],
      ["LC", "LCA", "662", "ISO 3166-2:LC"],
      ["PM", "SPM", "666", "ISO 3166-2:PM"],
      ["VC", "VCT", "670", "ISO 3166-2:VC"],
      ["WS", "WSM", "882", "ISO 3166-2:WS"],
      ["SM", "SMR", "674", "ISO 3166-2:SM"],
      ["ST", "STP", "678", "ISO 3166-2:ST"],
      ["SA", "SAU", "682", "ISO 3166-2:SA"],
      ["SN", "SEN", "686", "ISO 3166-2:SN"],
      ["SC", "SYC", "690", "ISO 3166-2:SC"],
      ["SL", "SLE", "694", "ISO 3166-2:SL"],
      ["SG", "SGP", "702", "ISO 3166-2:SG"],
      ["SK", "SVK", "703", "ISO 3166-2:SK"],
      ["SI", "SVN", "705", "ISO 3166-2:SI"],
      ["SB", "SLB", "090", "ISO 3166-2:SB"],
      ["SO", "SOM", "706", "ISO 3166-2:SO"],
      ["ZA", "ZAF", "710", "ISO 3166-2:ZA"],
      ["GS", "SGS", "239", "ISO 3166-2:GS"],
      ["ES", "ESP", "724", "ISO 3166-2:ES"],
      ["LK", "LKA", "144", "ISO 3166-2:LK"],
      ["SD", "SDN", "729", "ISO 3166-2:SD"],
      ["SR", "SUR", "740", "ISO 3166-2:SR"],
      ["SJ", "SJM", "744", "ISO 3166-2:SJ"],
      ["SZ", "SWZ", "748", "ISO 3166-2:SZ"],
      ["SE", "SWE", "752", "ISO 3166-2:SE"],
      ["CH", "CHE", "756", "ISO 3166-2:CH"],
      ["SY", "SYR", "760", "ISO 3166-2:SY"],
      ["TW", "TWN", "158", "ISO 3166-2:TW"],
      ["TJ", "TJK", "762", "ISO 3166-2:TJ"],
      ["TZ", "TZA", "834", "ISO 3166-2:TZ"],
      ["TH", "THA", "764", "ISO 3166-2:TH"],
      ["TL", "TLS", "626", "ISO 3166-2:TL"],
      ["TG", "TGO", "768", "ISO 3166-2:TG"],
      ["TK", "TKL", "772", "ISO 3166-2:TK"],
      ["TO", "TON", "776", "ISO 3166-2:TO"],
      ["TT", "TTO", "780", "ISO 3166-2:TT"],
      ["TN", "TUN", "788", "ISO 3166-2:TN"],
      ["TR", "TUR", "792", "ISO 3166-2:TR"],
      ["TM", "TKM", "795", "ISO 3166-2:TM"],
      ["TC", "TCA", "796", "ISO 3166-2:TC"],
      ["TV", "TUV", "798", "ISO 3166-2:TV"],
      ["UG", "UGA", "800", "ISO 3166-2:UG"],
      ["UA", "UKR", "804", "ISO 3166-2:UA"],
      ["AE", "ARE", "784", "ISO 3166-2:AE"],
      ["GB", "GBR", "826", "ISO 3166-2:GB"],
      ["US", "USA", "840", "ISO 3166-2:US"],
      ["UM", "UMI", "581", "ISO 3166-2:UM"],
      ["UY", "URY", "858", "ISO 3166-2:UY"],
      ["UZ", "UZB", "860", "ISO 3166-2:UZ"],
      ["VU", "VUT", "548", "ISO 3166-2:VU"],
      ["VE", "VEN", "862", "ISO 3166-2:VE"],
      ["VN", "VNM", "704", "ISO 3166-2:VN"],
      ["VG", "VGB", "092", "ISO 3166-2:VG"],
      ["VI", "VIR", "850", "ISO 3166-2:VI"],
      ["WF", "WLF", "876", "ISO 3166-2:WF"],
      ["EH", "ESH", "732", "ISO 3166-2:EH"],
      ["YE", "YEM", "887", "ISO 3166-2:YE"],
      ["ZM", "ZMB", "894", "ISO 3166-2:ZM"],
      ["ZW", "ZWE", "716", "ISO 3166-2:ZW"],
      ["AX", "ALA", "248", "ISO 3166-2:AX"],
      ["BQ", "BES", "535", "ISO 3166-2:BQ"],
      ["CW", "CUW", "531", "ISO 3166-2:CW"],
      ["GG", "GGY", "831", "ISO 3166-2:GG"],
      ["IM", "IMN", "833", "ISO 3166-2:IM"],
      ["JE", "JEY", "832", "ISO 3166-2:JE"],
      ["ME", "MNE", "499", "ISO 3166-2:ME"],
      ["BL", "BLM", "652", "ISO 3166-2:BL"],
      ["MF", "MAF", "663", "ISO 3166-2:MF"],
      ["RS", "SRB", "688", "ISO 3166-2:RS"],
      ["SX", "SXM", "534", "ISO 3166-2:SX"],
      ["SS", "SSD", "728", "ISO 3166-2:SS"],
      ["XK", "XKK", "983", "ISO 3166-2:XK"]
    ];
  }
});

// ../../common/temp/node_modules/.pnpm/i18n-iso-countries@7.14.0/node_modules/i18n-iso-countries/supportedLocales.json
var require_supportedLocales = __commonJS({
  "../../common/temp/node_modules/.pnpm/i18n-iso-countries@7.14.0/node_modules/i18n-iso-countries/supportedLocales.json"(exports, module) {
    module.exports = [
      "br",
      "cy",
      "dv",
      "sw",
      "eu",
      "af",
      "am",
      "ha",
      "ku",
      "ml",
      "mt",
      "no",
      "ps",
      "sd",
      "so",
      "sq",
      "ta",
      "tg",
      "tt",
      "ug",
      "ur",
      "vi",
      "ar",
      "az",
      "be",
      "bg",
      "bn",
      "bs",
      "ca",
      "cs",
      "da",
      "de",
      "el",
      "en",
      "es",
      "et",
      "fa",
      "fi",
      "fr",
      "ga",
      "gl",
      "he",
      "hi",
      "hr",
      "hu",
      "hy",
      "id",
      "is",
      "it",
      "ja",
      "ka",
      "kk",
      "km",
      "ko",
      "ky",
      "lt",
      "lv",
      "mk",
      "mn",
      "mr",
      "ms",
      "nb",
      "nl",
      "nn",
      "pl",
      "pt",
      "ro",
      "ru",
      "sk",
      "sl",
      "sr",
      "sv",
      "th",
      "tk",
      "tr",
      "uk",
      "uz",
      "zh"
    ];
  }
});

// ../../common/temp/node_modules/.pnpm/diacritics@1.3.0/node_modules/diacritics/index.js
var require_diacritics = __commonJS({
  "../../common/temp/node_modules/.pnpm/diacritics@1.3.0/node_modules/diacritics/index.js"(exports) {
    "use strict";
    exports.remove = removeDiacritics;
    var replacementList = [
      {
        base: " ",
        chars: "\xA0"
      },
      {
        base: "0",
        chars: "\u07C0"
      },
      {
        base: "A",
        chars: "\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
      },
      {
        base: "AA",
        chars: "\uA732"
      },
      {
        base: "AE",
        chars: "\xC6\u01FC\u01E2"
      },
      {
        base: "AO",
        chars: "\uA734"
      },
      {
        base: "AU",
        chars: "\uA736"
      },
      {
        base: "AV",
        chars: "\uA738\uA73A"
      },
      {
        base: "AY",
        chars: "\uA73C"
      },
      {
        base: "B",
        chars: "\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0181"
      },
      {
        base: "C",
        chars: "\u24B8\uFF23\uA73E\u1E08\u0106C\u0108\u010A\u010C\xC7\u0187\u023B"
      },
      {
        base: "D",
        chars: "\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018A\u0189\u1D05\uA779"
      },
      {
        base: "Dh",
        chars: "\xD0"
      },
      {
        base: "DZ",
        chars: "\u01F1\u01C4"
      },
      {
        base: "Dz",
        chars: "\u01F2\u01C5"
      },
      {
        base: "E",
        chars: "\u025B\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E\u1D07"
      },
      {
        base: "F",
        chars: "\uA77C\u24BB\uFF26\u1E1E\u0191\uA77B"
      },
      {
        base: "G",
        chars: "\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E\u0262"
      },
      {
        base: "H",
        chars: "\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
      },
      {
        base: "I",
        chars: "\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
      },
      {
        base: "J",
        chars: "\u24BF\uFF2A\u0134\u0248\u0237"
      },
      {
        base: "K",
        chars: "\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
      },
      {
        base: "L",
        chars: "\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
      },
      {
        base: "LJ",
        chars: "\u01C7"
      },
      {
        base: "Lj",
        chars: "\u01C8"
      },
      {
        base: "M",
        chars: "\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C\u03FB"
      },
      {
        base: "N",
        chars: "\uA7A4\u0220\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u019D\uA790\u1D0E"
      },
      {
        base: "NJ",
        chars: "\u01CA"
      },
      {
        base: "Nj",
        chars: "\u01CB"
      },
      {
        base: "O",
        chars: "\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
      },
      {
        base: "OE",
        chars: "\u0152"
      },
      {
        base: "OI",
        chars: "\u01A2"
      },
      {
        base: "OO",
        chars: "\uA74E"
      },
      {
        base: "OU",
        chars: "\u0222"
      },
      {
        base: "P",
        chars: "\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
      },
      {
        base: "Q",
        chars: "\u24C6\uFF31\uA756\uA758\u024A"
      },
      {
        base: "R",
        chars: "\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
      },
      {
        base: "S",
        chars: "\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
      },
      {
        base: "T",
        chars: "\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
      },
      {
        base: "Th",
        chars: "\xDE"
      },
      {
        base: "TZ",
        chars: "\uA728"
      },
      {
        base: "U",
        chars: "\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
      },
      {
        base: "V",
        chars: "\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
      },
      {
        base: "VY",
        chars: "\uA760"
      },
      {
        base: "W",
        chars: "\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
      },
      {
        base: "X",
        chars: "\u24CD\uFF38\u1E8A\u1E8C"
      },
      {
        base: "Y",
        chars: "\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
      },
      {
        base: "Z",
        chars: "\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
      },
      {
        base: "a",
        chars: "\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250\u0251"
      },
      {
        base: "aa",
        chars: "\uA733"
      },
      {
        base: "ae",
        chars: "\xE6\u01FD\u01E3"
      },
      {
        base: "ao",
        chars: "\uA735"
      },
      {
        base: "au",
        chars: "\uA737"
      },
      {
        base: "av",
        chars: "\uA739\uA73B"
      },
      {
        base: "ay",
        chars: "\uA73D"
      },
      {
        base: "b",
        chars: "\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253\u0182"
      },
      {
        base: "c",
        chars: "\uFF43\u24D2\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
      },
      {
        base: "d",
        chars: "\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\u018B\u13E7\u0501\uA7AA"
      },
      {
        base: "dh",
        chars: "\xF0"
      },
      {
        base: "dz",
        chars: "\u01F3\u01C6"
      },
      {
        base: "e",
        chars: "\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u01DD"
      },
      {
        base: "f",
        chars: "\u24D5\uFF46\u1E1F\u0192"
      },
      {
        base: "ff",
        chars: "\uFB00"
      },
      {
        base: "fi",
        chars: "\uFB01"
      },
      {
        base: "fl",
        chars: "\uFB02"
      },
      {
        base: "ffi",
        chars: "\uFB03"
      },
      {
        base: "ffl",
        chars: "\uFB04"
      },
      {
        base: "g",
        chars: "\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\uA77F\u1D79"
      },
      {
        base: "h",
        chars: "\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
      },
      {
        base: "hv",
        chars: "\u0195"
      },
      {
        base: "i",
        chars: "\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
      },
      {
        base: "j",
        chars: "\u24D9\uFF4A\u0135\u01F0\u0249"
      },
      {
        base: "k",
        chars: "\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
      },
      {
        base: "l",
        chars: "\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747\u026D"
      },
      {
        base: "lj",
        chars: "\u01C9"
      },
      {
        base: "m",
        chars: "\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
      },
      {
        base: "n",
        chars: "\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u043B\u0509"
      },
      {
        base: "nj",
        chars: "\u01CC"
      },
      {
        base: "o",
        chars: "\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\uA74B\uA74D\u0275\u0254\u1D11"
      },
      {
        base: "oe",
        chars: "\u0153"
      },
      {
        base: "oi",
        chars: "\u01A3"
      },
      {
        base: "oo",
        chars: "\uA74F"
      },
      {
        base: "ou",
        chars: "\u0223"
      },
      {
        base: "p",
        chars: "\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755\u03C1"
      },
      {
        base: "q",
        chars: "\u24E0\uFF51\u024B\uA757\uA759"
      },
      {
        base: "r",
        chars: "\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
      },
      {
        base: "s",
        chars: "\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B\u0282"
      },
      {
        base: "ss",
        chars: "\xDF"
      },
      {
        base: "t",
        chars: "\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
      },
      {
        base: "th",
        chars: "\xFE"
      },
      {
        base: "tz",
        chars: "\uA729"
      },
      {
        base: "u",
        chars: "\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
      },
      {
        base: "v",
        chars: "\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
      },
      {
        base: "vy",
        chars: "\uA761"
      },
      {
        base: "w",
        chars: "\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
      },
      {
        base: "x",
        chars: "\u24E7\uFF58\u1E8B\u1E8D"
      },
      {
        base: "y",
        chars: "\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
      },
      {
        base: "z",
        chars: "\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
      }
    ];
    var diacriticsMap = {};
    for (i = 0; i < replacementList.length; i += 1) {
      chars = replacementList[i].chars;
      for (j = 0; j < chars.length; j += 1) {
        diacriticsMap[chars[j]] = replacementList[i].base;
      }
    }
    var chars;
    var j;
    var i;
    function removeDiacritics(str) {
      return str.replace(/[^\u0000-\u007e]/g, function(c) {
        return diacriticsMap[c] || c;
      });
    }
    exports.replacementList = replacementList;
    exports.diacriticsMap = diacriticsMap;
  }
});

// ../../common/temp/node_modules/.pnpm/i18n-iso-countries@7.14.0/node_modules/i18n-iso-countries/index.js
var require_i18n_iso_countries = __commonJS({
  "../../common/temp/node_modules/.pnpm/i18n-iso-countries@7.14.0/node_modules/i18n-iso-countries/index.js"(exports) {
    "use strict";
    var codes = require_codes();
    var supportedLocales = require_supportedLocales();
    var removeDiacritics = require_diacritics().remove;
    var registeredLocales = {};
    var alpha2 = {};
    var alpha3 = {};
    var numeric = {};
    var invertedNumeric = {};
    codes.forEach(function(codeInformation) {
      const s = codeInformation;
      alpha2[s[0]] = s[1];
      alpha3[s[1]] = s[0];
      numeric[s[2]] = s[0];
      invertedNumeric[s[0]] = s[2];
    });
    function formatNumericCode(code) {
      return String("000" + (code ? code : "")).slice(-3);
    }
    function hasOwnProperty(object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    }
    function localeFilter(localeList, filter) {
      return Object.keys(localeList).reduce(function(newLocaleList, alpha22) {
        const nameList = localeList[alpha22];
        newLocaleList[alpha22] = filter(nameList, alpha22);
        return newLocaleList;
      }, {});
    }
    function filterNameBy(type, countryNameList) {
      switch (type) {
        case "official":
          return Array.isArray(countryNameList) ? countryNameList[0] : countryNameList;
        case "all":
          return typeof countryNameList === "string" ? [countryNameList] : countryNameList;
        case "alias":
          return Array.isArray(countryNameList) ? countryNameList[1] || countryNameList[0] : countryNameList;
        default:
          throw new TypeError(
            "LocaleNameType must be one of these: all, official, alias!"
          );
      }
    }
    exports.registerLocale = function(localeData) {
      if (!localeData.locale) {
        throw new TypeError("Missing localeData.locale");
      }
      if (!localeData.countries) {
        throw new TypeError("Missing localeData.countries");
      }
      registeredLocales[localeData.locale] = localeData.countries;
    };
    function alpha3ToAlpha2(code) {
      return alpha3[code];
    }
    exports.alpha3ToAlpha2 = alpha3ToAlpha2;
    function alpha2ToAlpha3(code) {
      return alpha2[code];
    }
    exports.alpha2ToAlpha3 = alpha2ToAlpha3;
    function alpha3ToNumeric(code) {
      return invertedNumeric[alpha3ToAlpha2(code)];
    }
    exports.alpha3ToNumeric = alpha3ToNumeric;
    function alpha2ToNumeric(code) {
      return invertedNumeric[code];
    }
    exports.alpha2ToNumeric = alpha2ToNumeric;
    function numericToAlpha3(code) {
      const padded = formatNumericCode(code);
      return alpha2ToAlpha3(numeric[padded]);
    }
    exports.numericToAlpha3 = numericToAlpha3;
    function numericToAlpha2(code) {
      const padded = formatNumericCode(code);
      return numeric[padded];
    }
    exports.numericToAlpha2 = numericToAlpha2;
    function toAlpha3(code) {
      if (typeof code === "string") {
        if (/^[0-9]*$/.test(code)) {
          return numericToAlpha3(code);
        }
        if (code.length === 2) {
          return alpha2ToAlpha3(code.toUpperCase());
        }
        if (code.length === 3) {
          return code.toUpperCase();
        }
      }
      if (typeof code === "number") {
        return numericToAlpha3(code);
      }
      return void 0;
    }
    exports.toAlpha3 = toAlpha3;
    function toAlpha2(code) {
      if (typeof code === "string") {
        if (/^[0-9]*$/.test(code)) {
          return numericToAlpha2(code);
        }
        if (code.length === 2) {
          return code.toUpperCase();
        }
        if (code.length === 3) {
          return alpha3ToAlpha2(code.toUpperCase());
        }
      }
      if (typeof code === "number") {
        return numericToAlpha2(code);
      }
      return void 0;
    }
    exports.toAlpha2 = toAlpha2;
    exports.getName = function(code, lang, options = {}) {
      if (!("select" in options)) {
        options.select = "official";
      }
      try {
        const codeMaps = registeredLocales[lang.toLowerCase()];
        const nameList = codeMaps[toAlpha2(code)];
        return filterNameBy(options.select, nameList);
      } catch (err) {
        return void 0;
      }
    };
    exports.getNames = function(lang, options = {}) {
      if (!("select" in options)) {
        options.select = "official";
      }
      const localeList = registeredLocales[lang.toLowerCase()];
      if (localeList === void 0) return {};
      return localeFilter(localeList, function(nameList) {
        return filterNameBy(options.select, nameList);
      });
    };
    exports.getAlpha2Code = function(name, lang) {
      const normalizeString = (string) => string.toLowerCase();
      const areSimilar = (a, b) => normalizeString(a) === normalizeString(b);
      try {
        const codenames = registeredLocales[lang.toLowerCase()];
        for (const p in codenames) {
          if (!hasOwnProperty(codenames, p)) {
            continue;
          }
          if (typeof codenames[p] === "string") {
            if (areSimilar(codenames[p], name)) {
              return p;
            }
          }
          if (Array.isArray(codenames[p])) {
            for (const mappedName of codenames[p]) {
              if (areSimilar(mappedName, name)) {
                return p;
              }
            }
          }
        }
        return void 0;
      } catch (err) {
        return void 0;
      }
    };
    exports.getSimpleAlpha2Code = function(name, lang) {
      const normalizeString = (string) => removeDiacritics(string.toLowerCase());
      const areSimilar = (a, b) => normalizeString(a) === normalizeString(b);
      try {
        const codenames = registeredLocales[lang.toLowerCase()];
        for (const p in codenames) {
          if (!hasOwnProperty(codenames, p)) {
            continue;
          }
          if (typeof codenames[p] === "string") {
            if (areSimilar(codenames[p], name)) {
              return p;
            }
          }
          if (Array.isArray(codenames[p])) {
            for (const mappedName of codenames[p]) {
              if (areSimilar(mappedName, name)) {
                return p;
              }
            }
          }
        }
        return void 0;
      } catch (err) {
        return void 0;
      }
    };
    exports.getAlpha2Codes = function() {
      return alpha2;
    };
    exports.getAlpha3Code = function(name, lang) {
      const alpha22 = exports.getAlpha2Code(name, lang);
      if (alpha22) {
        return exports.toAlpha3(alpha22);
      } else {
        return void 0;
      }
    };
    exports.getSimpleAlpha3Code = function(name, lang) {
      const alpha22 = exports.getSimpleAlpha2Code(name, lang);
      if (alpha22) {
        return exports.toAlpha3(alpha22);
      } else {
        return void 0;
      }
    };
    exports.getAlpha3Codes = function() {
      return alpha3;
    };
    exports.getNumericCodes = function() {
      return numeric;
    };
    exports.langs = function() {
      return Object.keys(registeredLocales);
    };
    exports.getSupportedLanguages = function() {
      return supportedLocales;
    };
    exports.isValid = function(code) {
      if (!code) {
        return false;
      }
      const coerced = code.toString().toUpperCase();
      return hasOwnProperty(alpha3, coerced) || hasOwnProperty(alpha2, coerced) || hasOwnProperty(numeric, coerced);
    };
  }
});

// src/services/error.service.ts
var ErrorService = class {
  /** Logger instance for error reporting */
  logger;
  /**
   * Creates a new ErrorService instance
   *
   * @param logger - LoggerFactory instance for creating the error logger
   */
  constructor(logger5) {
    this.logger = logger5.getLogger("error");
  }
  /**
   * Logs an error message and re-throws the error
   *
   * This method provides a centralized point for error handling that ensures
   * all errors are logged before being propagated. It supports both standard
   * Error objects and ContextAwareError objects.
   *
   * @param error - The error to log and throw (standard Error or ContextAwareError)
   * @throws The same error that was passed in, after logging
   *
   * @example
   * ```typescript
   * try {
   *   await apiCall();
   * } catch (error) {
   *   errorService.throwError(error); // Logs error message and re-throws
   * }
   * ```
   */
  throwError = (error) => {
    this.logger.error(error.message)();
    throw error;
  };
};

// src/services/log.service.ts
var logLevels = {
  log_raise_error: 1,
  log_with_warnings: 2,
  trace: 3,
  debug: 4,
  info: 5,
  warn: 6,
  error: 7,
  disable: 8
};
var LoggerFactory = class _LoggerFactory {
  /**
   * Current global logging level that determines which messages are displayed
   */
  logLevel;
  /**
   * Console implementation used for actual output (allows for testing/mocking)
   */
  mockConsole;
  /**
   * Creates a new LoggerFactory with the specified configuration
   *
   * @param logLevel - Global logging level (defaults to "log_with_warnings")
   * @param mockConsole - Console implementation to use (defaults to window.console)
   * @throws Error if the provided logLevel is invalid
   */
  constructor(logLevel = "log_with_warnings", mockConsole = null) {
    this.logLevel = logLevel;
    if (!logLevels[logLevel]) {
      throw Error(`Invalid log level ${logLevel} allowed: ${JSON.stringify(logLevels)}`);
    }
    if (mockConsole) {
      this.mockConsole = mockConsole;
    } else {
      this.mockConsole = console;
    }
  }
  /**
   * No-op function used when log messages are filtered out by level
   */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  dummy() {
  }
  /**
   * Updates the global logging level for all loggers created by this factory
   *
   * @param logWarnings - New logging level to apply
   */
  setLogWarnings(logWarnings) {
    this.logLevel = logWarnings;
  }
  /**
   * Gets the current global logging level
   *
   * @returns The current LogLevel setting
   */
  getLogWarnings() {
    return this.logLevel;
  }
  /**
   * @return Single log function that can be called, e.g.
   * getSingleLogger(...)('hello wolrd')
   * @param name - badge string, that every log will be marked with
   * @param color - css color of badge, e.g. #FFFAAA
   * @param fn - binded function that will be called eventually, e.g.
   * console.log
   */
  getSingleLoggerColor(name, color, fn) {
    return this.getSingleLoggerStyle(name, this.getColorStyle(color), fn);
  }
  /**
   * @return Single log function that can be called, e.g.
   * getSingleLogger(...)('hello wolrd')
   * @param name - badge string, that every log will be marked with
   * @param fn - binded function that will be called eventually, e.g.
   * console.log
   */
  getSingleLogger(name, fn) {
    const color = this.getRandomColor(name);
    return this.getSingleLoggerStyle(name, this.getColorStyle(color), fn);
  }
  /**
   * @return Single log function that can be called, e.g.
   * getSingleLogger(...)('hello wolrd')
   * @param fn - binded function that will be called eventually, e.g.
   * console.log
   * @param name - badge string, that every log will be marked with
   * @param minLevel - initial logging level, .e.g 2
   * @param style - css style, e.g. `font-size: 10px; border-color: red`
   */
  getSingleLoggerStyle(name, style, fn, minLevel = "log_with_warnings") {
    return (...args1) => {
      if (logLevels[this.logLevel] > logLevels[minLevel]) {
        return this.dummy;
      }
      const args = Array.prototype.slice.call(args1);
      const parts = args.shift().split("{}");
      const params = [this.mockConsole, "%c" + name, style];
      for (let i = 0; i < parts.length; i++) {
        params.push(parts[i]);
        if (typeof args[i] !== "undefined") {
          params.push(args[i]);
        }
      }
      if (parts.length - 1 !== args.length) {
        if (this.logLevel === "log_with_warnings") {
          this.mockConsole.error("MissMatch amount of arguments");
        } else if (this.logLevel === "log_raise_error") {
          throw new Error("MissMatch amount of arguments");
        }
      }
      return Function.prototype.bind.apply(fn, params);
    };
  }
  /**
   * @return logger with badged tag
   * @param name - badge string, that every log will be marked with
   * @param color - css color of badge, e.g. #FFFAAA
   */
  getLoggerColor(name, color) {
    return this.getLoggerStyle(name, this.getColorStyle(color));
  }
  /**
   * @return css for badge
   * @param color - css color, e.g. #FFFAAA
   */
  getColorStyle(color) {
    return `color: white; background-color: ${color}; padding: 2px 6px; border-radius: 2px; font-size: 10px`;
  }
  /**
   * Hash function from https://stackoverflow.com/a/52171480/3872976
   */
  static getHash(str, seed = 0) {
    let h1 = 3735928559 ^ seed, h2 = 1103547991 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
      ch = str.charCodeAt(i);
      h1 = Math.imul(h1 ^ ch, 2654435761);
      h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507) ^ Math.imul(h2 ^ h2 >>> 13, 3266489909);
    h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507) ^ Math.imul(h1 ^ h1 >>> 13, 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
  }
  /**
   * Generates a random color based on the hash of the string
   **/
  getRandomColor(str = "") {
    const hash = _LoggerFactory.getHash(str);
    let color = "#";
    for (let i = 0; i < 3; i++) {
      color += ("00" + ((hash >> i * 7 & 127) + 8).toString(16)).substr(-2);
    }
    return color;
  }
  /**
   * @return a logger object with generated colored tag by hash of name
   * @param name - badge string, that every log will be marked with
   */
  getLogger(name) {
    return this.getLoggerColor(name, this.getRandomColor(name));
  }
  /**
   * @return a logger object
   * @param name - badge string, that every log will be marked with
   * @param style - css style, e.g. `font-size: 10px; border-color: red`
   */
  getLoggerStyle(name, style) {
    return {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      trace: this.getSingleLoggerStyle(name, style, this.mockConsole.trace, "trace"),
      // eslint-disable-next-line @typescript-eslint/unbound-method
      debug: this.getSingleLoggerStyle(name, style, this.mockConsole.debug, "debug"),
      // eslint-disable-next-line @typescript-eslint/unbound-method
      log: this.getSingleLoggerStyle(name, style, this.mockConsole.log, "info"),
      // eslint-disable-next-line @typescript-eslint/unbound-method
      warn: this.getSingleLoggerStyle(name, style, this.mockConsole.warn, "warn"),
      // eslint-disable-next-line @typescript-eslint/unbound-method
      error: this.getSingleLoggerStyle(name, style, this.mockConsole.error, "error")
    };
  }
};

// src/services/index.ts
var logger = new LoggerFactory("debug");
var errorService = new ErrorService(logger);
function useLogger(name) {
  return logger.getLogger(name);
}
function useErrorService() {
  return errorService;
}

// src/utils/avatar.ts
function convertNameToInitials(fullName, options) {
  const { placeholder = "?", charCount = 2 } = options ?? {};
  if (!fullName) return placeholder;
  const parts = fullName.trim().split(/\s+/).map((p) => [...p]);
  const initials = new Array(parts.length).fill("");
  let pointer = 0;
  let charsRemaining = parts.reduce((sum, arr) => sum + arr.length, 0);
  while (initials.join("").length < charCount && charsRemaining > 0) {
    while (parts[pointer].length === 0) {
      pointer = (pointer + 1) % parts.length;
    }
    initials[pointer] += parts[pointer].shift();
    charsRemaining--;
    pointer = (pointer + 1) % parts.length;
  }
  return initials.join("").toUpperCase();
}

// src/utils/countries.ts
var import_i18n_iso_countries = __toESM(require_i18n_iso_countries(), 1);

// ../../common/temp/node_modules/.pnpm/i18n-iso-countries@7.14.0/node_modules/i18n-iso-countries/langs/de.json
var de_default = {
  locale: "de",
  countries: {
    AF: "Afghanistan",
    EG: "\xC4gypten",
    AX: "\xC5land",
    AL: "Albanien",
    DZ: "Algerien",
    AS: "Amerikanisch-Samoa",
    VI: "Amerikanische Jungferninseln",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antarktis",
    AG: "Antigua und Barbuda",
    GQ: "\xC4quatorialguinea",
    AR: "Argentinien",
    AM: "Armenien",
    AW: "Aruba",
    AZ: "Aserbaidschan",
    ET: "\xC4thiopien",
    AU: "Australien",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesch",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgien",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    BT: "Bhutan",
    BO: "Bolivien",
    BQ: "Bonaire",
    BA: "Bosnien und Herzegowina",
    BW: "Botswana",
    BV: "Bouvetinsel",
    BR: "Brasilien",
    VG: "Britische Jungferninseln",
    IO: "Britisches Territorium im Indischen Ozean",
    BN: "Brunei Darussalam",
    BG: "Bulgarien",
    BF: "Burkina Faso",
    BI: "Burundi",
    CL: "Chile",
    CN: "China",
    CK: "Cookinseln",
    CR: "Costa Rica",
    CI: "Elfenbeink\xFCste",
    CW: "Cura\xE7ao",
    DK: "D\xE4nemark",
    DE: "Deutschland",
    DM: "Dominica",
    DO: "Dominikanische Republik",
    DJ: "Dschibuti",
    EC: "Ecuador",
    SV: "El Salvador",
    ER: "Eritrea",
    EE: "Estland",
    FK: "Falklandinseln",
    FO: "F\xE4r\xF6er",
    FJ: "Fidschi",
    FI: "Finnland",
    FR: "Frankreich",
    GF: "Franz\xF6sisch-Guayana",
    PF: "Franz\xF6sisch-Polynesien",
    TF: "Franz\xF6sische S\xFCd- und Antarktisgebiete",
    GA: "Gabun",
    GM: "Gambia",
    GE: "Georgien",
    GH: "Ghana",
    GI: "Gibraltar",
    GD: "Grenada",
    GR: "Griechenland",
    GL: "Gr\xF6nland",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernsey",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HM: "Heard und McDonaldinseln",
    HN: "Honduras",
    HK: ["Hongkong", "Hong Kong"],
    IN: "Indien",
    ID: "Indonesien",
    IM: "Insel Man",
    IQ: "Irak",
    IR: "Iran",
    IE: "Irland",
    IS: "Island",
    IL: "Israel",
    IT: "Italien",
    JM: "Jamaika",
    JP: "Japan",
    YE: "Jemen",
    JE: "Jersey",
    JO: "Jordanien",
    KY: "Kaimaninseln",
    KH: "Kambodscha",
    CM: "Kamerun",
    CA: "Kanada",
    CV: "Kap Verde",
    KZ: "Kasachstan",
    QA: "Katar",
    KE: "Kenia",
    KG: "Kirgisistan",
    KI: "Kiribati",
    CC: "Kokosinseln",
    CO: "Kolumbien",
    KM: "Komoren",
    CD: "Kongo",
    KP: "Nordkorea",
    KR: "S\xFCdkorea",
    HR: "Kroatien",
    CU: "Kuba",
    KW: "Kuwait",
    LA: "Laos",
    LS: "Lesotho",
    LV: "Lettland",
    LB: "Libanon",
    LR: "Liberia",
    LY: "Libyen",
    LI: "Liechtenstein",
    LT: "Litauen",
    LU: "Luxemburg",
    MO: "Macao",
    MG: "Madagaskar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Malediven",
    ML: "Mali",
    MT: "Malta",
    MA: "Marokko",
    MH: "Marshallinseln",
    MQ: "Martinique",
    MR: "Mauretanien",
    MU: "Mauritius",
    YT: "Mayotte",
    MX: "Mexiko",
    FM: "Mikronesien",
    MD: "Moldawien",
    MC: "Monaco",
    MN: "Mongolei",
    ME: "Montenegro",
    MS: "Montserrat",
    MZ: "Mosambik",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NC: "Neukaledonien",
    NZ: "Neuseeland",
    NI: "Nicaragua",
    NL: "Niederlande",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    MK: "Nordmazedonien",
    MP: "N\xF6rdliche Marianen",
    NF: "Norfolkinsel",
    NO: "Norwegen",
    OM: "Oman",
    AT: "\xD6sterreich",
    TL: "Osttimor",
    PK: "Pakistan",
    PS: "Staat Pal\xE4stina",
    PW: "Palau",
    PA: "Panama",
    PG: "Papua-Neuguinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippinen",
    PN: "Pitcairninseln",
    PL: "Polen",
    PT: "Portugal",
    PR: "Puerto Rico",
    TW: "Taiwan",
    CG: "Republik Kongo",
    RE: "R\xE9union",
    RW: "Ruanda",
    RO: "Rum\xE4nien",
    RU: ["Russische F\xF6deration", "Russland"],
    BL: "Saint-Barth\xE9lemy",
    MF: "Saint-Martin",
    SB: "Salomonen",
    ZM: "Sambia",
    WS: "Samoa",
    SM: "San Marino",
    ST: "S\xE3o Tom\xE9 und Pr\xEDncipe",
    SA: "Saudi-Arabien",
    SE: "Schweden",
    CH: "Schweiz",
    SN: "Senegal",
    RS: "Serbien",
    SC: "Seychellen",
    SL: "Sierra Leone",
    ZW: "Simbabwe",
    SG: "Singapur",
    SX: "Sint Maarten",
    SK: "Slowakei",
    SI: "Slowenien",
    SO: "Somalia",
    ES: "Spanien",
    LK: "Sri Lanka",
    SH: "St. Helena",
    KN: "St. Kitts und Nevis",
    LC: "St. Lucia",
    PM: "Saint-Pierre und Miquelon",
    VC: "St. Vincent und die Grenadinen",
    ZA: "S\xFCdafrika",
    SD: "Sudan",
    GS: "S\xFCdgeorgien und die S\xFCdlichen Sandwichinseln",
    SS: "S\xFCdsudan",
    SR: "Suriname",
    SJ: "Svalbard und Jan Mayen",
    SZ: "Eswatini",
    SY: "Syrien, Arabische Republik",
    TJ: "Tadschikistan",
    TZ: ["Tansania, Vereinigte Republik", "Tansania"],
    TH: "Thailand",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad und Tobago",
    TD: "Tschad",
    CZ: ["Tschechische Republik", "Tschechien"],
    TN: "Tunesien",
    TR: "T\xFCrkei",
    TM: "Turkmenistan",
    TC: "Turks- und Caicosinseln",
    TV: "Tuvalu",
    UG: "Uganda",
    UA: "Ukraine",
    HU: "Ungarn",
    UM: "United States Minor Outlying Islands",
    UY: "Uruguay",
    UZ: "Usbekistan",
    VU: "Vanuatu",
    VA: "Vatikanstadt",
    VE: "Venezuela",
    AE: "Vereinigte Arabische Emirate",
    US: ["Vereinigte Staaten von Amerika", "Vereinigte Staaten", "USA"],
    GB: ["Vereinigtes K\xF6nigreich", "Gro\xDFbritannien"],
    VN: "Vietnam",
    WF: "Wallis und Futuna",
    CX: "Weihnachtsinsel",
    EH: "Westsahara",
    CF: "Zentralafrikanische Republik",
    CY: "Zypern",
    XK: "Kosovo"
  }
};

// ../../common/temp/node_modules/.pnpm/i18n-iso-countries@7.14.0/node_modules/i18n-iso-countries/langs/en.json
var en_default = {
  locale: "en",
  countries: {
    AF: "Afghanistan",
    AL: "Albania",
    DZ: "Algeria",
    AS: "American Samoa",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antarctica",
    AG: "Antigua and Barbuda",
    AR: "Argentina",
    AM: "Armenia",
    AW: "Aruba",
    AU: "Australia",
    AT: "Austria",
    AZ: "Azerbaijan",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgium",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    BT: "Bhutan",
    BO: "Bolivia",
    BA: "Bosnia and Herzegovina",
    BW: "Botswana",
    BV: "Bouvet Island",
    BR: "Brazil",
    IO: "British Indian Ocean Territory",
    BN: "Brunei Darussalam",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Cambodia",
    CM: "Cameroon",
    CA: "Canada",
    CV: "Cape Verde",
    KY: "Cayman Islands",
    CF: "Central African Republic",
    TD: "Chad",
    CL: "Chile",
    CN: ["People's Republic of China", "China"],
    CX: "Christmas Island",
    CC: "Cocos (Keeling) Islands",
    CO: "Colombia",
    KM: "Comoros",
    CG: ["Republic of the Congo", "Congo"],
    CD: ["Democratic Republic of the Congo", "Congo"],
    CK: "Cook Islands",
    CR: "Costa Rica",
    CI: ["Cote d'Ivoire", "C\xF4te d'Ivoire", "Ivory Coast"],
    HR: "Croatia",
    CU: "Cuba",
    CY: "Cyprus",
    CZ: ["Czech Republic", "Czechia"],
    DK: "Denmark",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Dominican Republic",
    EC: "Ecuador",
    EG: "Egypt",
    SV: "El Salvador",
    GQ: "Equatorial Guinea",
    ER: "Eritrea",
    EE: "Estonia",
    ET: "Ethiopia",
    FK: "Falkland Islands (Malvinas)",
    FO: "Faroe Islands",
    FJ: "Fiji",
    FI: "Finland",
    FR: "France",
    GF: "French Guiana",
    PF: "French Polynesia",
    TF: "French Southern Territories",
    GA: "Gabon",
    GM: ["Republic of The Gambia", "The Gambia", "Gambia"],
    GE: "Georgia",
    DE: "Germany",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Greece",
    GL: "Greenland",
    GD: "Grenada",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HM: "Heard Island and McDonald Islands",
    VA: "Holy See (Vatican City State)",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hungary",
    IS: "Iceland",
    IN: "India",
    ID: "Indonesia",
    IR: ["Islamic Republic of Iran", "Iran"],
    IQ: "Iraq",
    IE: "Ireland",
    IL: "Israel",
    IT: "Italy",
    JM: "Jamaica",
    JP: "Japan",
    JO: "Jordan",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    KP: "North Korea",
    KR: ["South Korea", "Korea, Republic of", "Republic of Korea"],
    KW: "Kuwait",
    KG: "Kyrgyzstan",
    LA: "Lao People's Democratic Republic",
    LV: "Latvia",
    LB: "Lebanon",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Libya",
    LI: "Liechtenstein",
    LT: "Lithuania",
    LU: "Luxembourg",
    MO: "Macao",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malta",
    MH: "Marshall Islands",
    MQ: "Martinique",
    MR: "Mauritania",
    MU: "Mauritius",
    YT: "Mayotte",
    MX: "Mexico",
    FM: "Micronesia, Federated States of",
    MD: "Moldova, Republic of",
    MC: "Monaco",
    MN: "Mongolia",
    MS: "Montserrat",
    MA: "Morocco",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: ["Netherlands", "The Netherlands", "Netherlands (Kingdom of the)"],
    NC: "New Caledonia",
    NZ: "New Zealand",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    NF: "Norfolk Island",
    MK: ["The Republic of North Macedonia", "North Macedonia"],
    MP: "Northern Mariana Islands",
    NO: "Norway",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palau",
    PS: ["State of Palestine", "Palestine"],
    PA: "Panama",
    PG: "Papua New Guinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippines",
    PN: ["Pitcairn", "Pitcairn Islands"],
    PL: "Poland",
    PT: "Portugal",
    PR: "Puerto Rico",
    QA: "Qatar",
    RE: "Reunion",
    RO: "Romania",
    RU: ["Russian Federation", "Russia"],
    RW: "Rwanda",
    SH: "Saint Helena",
    KN: "Saint Kitts and Nevis",
    LC: "Saint Lucia",
    PM: "Saint Pierre and Miquelon",
    VC: "Saint Vincent and the Grenadines",
    WS: "Samoa",
    SM: "San Marino",
    ST: "Sao Tome and Principe",
    SA: "Saudi Arabia",
    SN: "Senegal",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapore",
    SK: "Slovakia",
    SI: "Slovenia",
    SB: "Solomon Islands",
    SO: "Somalia",
    ZA: "South Africa",
    GS: "South Georgia and the South Sandwich Islands",
    ES: "Spain",
    LK: "Sri Lanka",
    SD: "Sudan",
    SR: "Suriname",
    SJ: "Svalbard and Jan Mayen",
    SZ: "Eswatini",
    SE: "Sweden",
    CH: "Switzerland",
    SY: "Syrian Arab Republic",
    TW: ["Taiwan, Province of China", "Taiwan"],
    TJ: "Tajikistan",
    TZ: ["United Republic of Tanzania", "Tanzania"],
    TH: "Thailand",
    TL: "Timor-Leste",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad and Tobago",
    TN: "Tunisia",
    TR: ["T\xFCrkiye", "Turkey"],
    TM: "Turkmenistan",
    TC: "Turks and Caicos Islands",
    TV: "Tuvalu",
    UG: "Uganda",
    UA: "Ukraine",
    AE: ["United Arab Emirates", "UAE"],
    GB: ["United Kingdom", "UK", "Great Britain"],
    US: ["United States of America", "United States", "USA", "U.S.A.", "US", "U.S."],
    UM: "United States Minor Outlying Islands",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VU: "Vanuatu",
    VE: "Venezuela",
    VN: "Vietnam",
    VG: "Virgin Islands, British",
    VI: "Virgin Islands, U.S.",
    WF: "Wallis and Futuna",
    EH: "Western Sahara",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabwe",
    AX: ["\xC5land Islands", "Aland Islands"],
    BQ: "Bonaire, Sint Eustatius and Saba",
    CW: "Cura\xE7ao",
    GG: "Guernsey",
    IM: "Isle of Man",
    JE: "Jersey",
    ME: "Montenegro",
    BL: "Saint Barth\xE9lemy",
    MF: "Saint Martin (French part)",
    RS: "Serbia",
    SX: "Sint Maarten (Dutch part)",
    SS: "South Sudan",
    XK: "Kosovo"
  }
};

// src/utils/countries.ts
var FALLBACK_LOCALE = en_default.locale;
for (const locale of [en_default, de_default]) {
  import_i18n_iso_countries.default.registerLocale(locale);
}
function getCountryNames(lang) {
  const names = import_i18n_iso_countries.default.getNames(lang);
  return Object.keys(names).length > 0 ? names : import_i18n_iso_countries.default.getNames(FALLBACK_LOCALE);
}
function getCountryOptions(lang) {
  return Object.entries(getCountryNames(lang)).map(([id, label]) => ({ id, label }));
}

// src/utils/dateFormatter.ts
import { format as formatWithDateFns, isValid, parse as parseWithDateFns } from "date-fns";
import { de, enUS } from "date-fns/locale";

// src/translations/index.ts
import { createI18n } from "vue-i18n";

// src/i18n/locales/de.json
var de_default2 = {
  common: {
    validation: {
      empty: "Dieses Feld kann nicht leer sein.",
      fieldRequired: "Dieses Feld darf nicht leer sein.",
      containLeast: "Dieses Feld ben\xF6tigt mindestens {length} Zeichen.",
      labelRequired: "{label} darf nicht leer sein."
    },
    label: {
      fieldNeedsValid: "Dieses Feld ben\xF6tigt eine g\xFCltige URL.",
      fieldNeedsValid2: "Dieses Feld ben\xF6tigt eine g\xFCltige E-Mail Adresse.",
      welcomeApp: "Willkommen zu unserer Applikation"
    },
    message: {
      paramCompletedSuccess: "{action} erfolgreich abgeschlossen.",
      paramError: "Fehler: {error}"
    }
  }
};

// src/i18n/locales/en.json
var en_default2 = {
  common: {
    validation: {
      empty: "Field can not be empty.",
      fieldRequired: "Field can't be empty.",
      containLeast: "Field must contain at least {length} characters.",
      labelRequired: "{label} can't be empty."
    },
    label: {
      fieldNeedsValid: "Field needs to be a valid URI.",
      fieldNeedsValid2: "Field needs to be a valid email address.",
      welcomeApp: "Welcome to our app"
    },
    message: {
      paramCompletedSuccess: "{action} completed successfully.",
      paramError: "Error: {error}"
    }
  }
};

// src/translations/index.ts
function createScaylaI18n(additionalMessages = {}) {
  return createI18n({
    legacy: false,
    locale: "en",
    fallbackLocale: "en",
    messages: {
      de: { ...de_default2, ...additionalMessages.de ?? {} },
      en: { ...en_default2, ...additionalMessages.en ?? {} }
    },
    missingWarn: false,
    fallbackWarn: false
  });
}
var _coreI18n = createI18n({
  legacy: false,
  locale: "en",
  fallbackLocale: "en",
  messages: { de: de_default2, en: en_default2 },
  missingWarn: false,
  fallbackWarn: false
});
var $t = (key, params) => _coreI18n.global.t(key, params ?? {});
var setLocale = (locale) => {
  _coreI18n.global.locale.value = locale;
};
var getLocale = () => _coreI18n.global.locale.value;

// src/utils/precisionFormat.ts
function cleanSeparators(format) {
  return format.replace(/([.\-/ ])\1+/g, "$1").replace(/^[.\-/ ]+|[.\-/ ]+$/g, "");
}
function applyDatePrecision(dateFormat, precision) {
  if (precision === "yy") return cleanSeparators(dateFormat.replace(/d+/g, "").replace(/M+/g, ""));
  if (precision === "mm") return cleanSeparators(dateFormat.replace(/d+/g, "").replace(/y+/g, ""));
  if (precision === "yy_mm") return cleanSeparators(dateFormat.replace(/d+/g, ""));
  return dateFormat;
}
var TIME_PRECISION_RANK = { hh: 1, hh_mm: 2, hh_mm_ss: 3, hh_mm_ss_ms: 4 };
function applyTimePrecision(timeFormat, precision) {
  const rank = precision ? TIME_PRECISION_RANK[precision] : void 0;
  if (!rank) return timeFormat;
  const meridiem = /\s*a+$/.exec(timeFormat)?.[0] ?? "";
  let core = meridiem ? timeFormat.slice(0, -meridiem.length) : timeFormat;
  if (rank < 4) core = core.replace(/\.S+/, "");
  if (rank < 3) core = core.replace(/:s+/, "");
  if (rank < 2) core = core.replace(/:m+/, "");
  return core + meridiem;
}

// src/utils/dateFormatter.ts
function resolveDateFnsLocale(locale) {
  return locale.toLowerCase().startsWith("de") ? de : enUS;
}
function toDate(value) {
  if (value === null || value === void 0 || value === "") return void 0;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? void 0 : date;
}
function localeFor(override) {
  return resolveDateFnsLocale(override ?? getLocale());
}
function formatWithLocale(value, pattern, opts = {}) {
  const date = toDate(value);
  if (!date) return "";
  return formatWithDateFns(date, pattern, { locale: localeFor(opts.locale) });
}
function parseDate(value, pattern, opts = {}) {
  const parsed = parseWithDateFns(value, pattern, /* @__PURE__ */ new Date(), { locale: localeFor(opts.locale) });
  return isValid(parsed) ? parsed : void 0;
}
function formatDate(value, pattern, opts = {}) {
  return formatWithLocale(value, applyDatePrecision(pattern, opts.precision), opts);
}
function formatTime(value, pattern, opts = {}) {
  return formatWithLocale(value, applyTimePrecision(pattern, opts.precision), opts);
}
function formatDateTime(value, datePattern, timePattern, opts = {}) {
  const datePart = applyDatePrecision(datePattern, opts.datePrecision);
  const timePart = applyTimePrecision(timePattern, opts.timePrecision);
  return formatWithLocale(value, `${datePart}${opts.separator ?? " "}${timePart}`, opts);
}

// src/utils/fileUploader.ts
function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(decimals));
  return `${formattedSize} ${sizes[i]}`;
}
function fileExtensionFromFileType(fileType, fileName) {
  const split = fileType.split("/");
  const ext = split.length === 2 ? split[1] : split[0].replace(".", "");
  const nameExt = fileName?.includes(".") ? fileName.split(".").pop() ?? "" : "";
  return {
    ext,
    icon: mimeTypeToIconMapping(fileType) ?? fileExtensionToIconMapping(nameExt || ext)
  };
}
function mimeTypeToIconMapping(mimeType) {
  const type = mimeType.toLocaleLowerCase();
  if (type.startsWith("image/")) {
    if (type === "image/vnd.adobe.photoshop") {
      return "tetrisly/32-file-Icon-psd";
    }
    return "phosphor/image-square";
  }
  switch (type) {
    case "application/msword":
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return "tetrisly/32-file-icon-word";
    case "application/vnd.ms-excel":
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
    case "application/vnd.oasis.opendocument.spreadsheet":
      return "tetrisly/32-file-icon-excel";
    case "text/csv":
      return "tetrisly/32-file-icon-spreadsheet";
    case "application/pdf":
      return "tetrisly/32-file-icon-pdf";
    case "application/rtf":
    case "application/vnd.oasis.opendocument.text":
    case "text/html":
    case "text/markdown":
    case "text/plain":
      return "tetrisly/32-file-icon-document";
    case "application/gzip":
    case "application/vnd.rar":
    case "application/x-7z-compressed":
    case "application/x-rar-compressed":
    case "application/x-tar":
    case "application/x-zip-compressed":
    case "application/zip":
      return "tetrisly/32-file-icon-zip";
    case "application/x-photoshop":
      return "tetrisly/32-file-Icon-psd";
    case "application/x-figma":
      return "tetrisly/32-file-icon-figma";
    case "application/vnd.sketch":
    case "application/x-sketch":
      return "tetrisly/32-file-icon-sketch";
    default:
      return void 0;
  }
}
function fileExtensionToIconMapping(ext) {
  switch (ext.toLocaleLowerCase()) {
    case "avif":
    case "bmp":
    case "gif":
    case "heic":
    case "jpeg":
    case "jpg":
    case "png":
    case "svg":
    case "svg+xml":
    case "tif":
    case "tiff":
    case "webp":
      return "phosphor/image-square";
    case "doc":
    case "docx":
      return "tetrisly/32-file-icon-word";
    case "xls":
    case "xlsx":
    case "ods":
      return "tetrisly/32-file-icon-excel";
    case "csv":
      return "tetrisly/32-file-icon-spreadsheet";
    case "pdf":
      return "tetrisly/32-file-icon-pdf";
    case "htm":
    case "html":
    case "md":
    case "odt":
    case "rtf":
    case "txt":
      return "tetrisly/32-file-icon-document";
    case "7z":
    case "gz":
    case "rar":
    case "tar":
    case "zip":
      return "tetrisly/32-file-icon-zip";
    case "psd":
      return "tetrisly/32-file-Icon-psd";
    case "sketch":
      return "tetrisly/32-file-icon-sketch";
    case "fig":
    case "jam":
      return "tetrisly/32-file-icon-figma";
    default:
      return "tetrisly/32-file-icon-file";
  }
}
async function getAllFilesFromDataTransfer(event) {
  const items = event.dataTransfer?.items;
  if (!items) return [];
  const files = [];
  const traverseEntry = async (entry, path = "") => {
    if (entry.isFile) {
      await new Promise((resolve) => {
        entry.file((file) => {
          files.push(new File([file], path + file.name, { type: file.type }));
          resolve();
        });
      });
    }
    if (entry.isDirectory) {
      const reader = entry.createReader();
      const readAllEntries = async () => {
        const allEntries = [];
        const readBatch = () => {
          return new Promise((resolve) => {
            reader.readEntries((entries3) => {
              resolve(entries3);
            });
          });
        };
        let entries2 = await readBatch();
        while (entries2.length > 0) {
          allEntries.push(...entries2);
          entries2 = await readBatch();
        }
        return allEntries;
      };
      const entries = await readAllEntries();
      await Promise.all(entries.map((e) => traverseEntry(e, path + entry.name + "/")));
    }
  };
  await Promise.all(
    Array.from(items).map(async (item) => {
      const entry = item.webkitGetAsEntry?.();
      if (entry) {
        await traverseEntry(entry);
      }
    })
  );
  return files;
}

// src/utils/handleError.ts
var handleError = (error) => {
  throw error;
};

// src/utils/runtimeData.ts
var logger2 = useLogger("core/runtimeData");
function getData(dataSelect) {
  try {
    if (typeof document === "undefined") {
      return {};
    }
    const inlineJsonElement = document.querySelector(`script[type="application/json"][data-selector="${dataSelect}"]`);
    if (!inlineJsonElement?.textContent) {
      return {};
    }
    if (inlineJsonElement.textContent.trim() === "// RUNTIME_CONFIGURATION") {
      return {};
    }
    return JSON.parse(inlineJsonElement.textContent);
  } catch (err) {
    logger2.error(`Couldn't read JSON data from ${dataSelect}`, err)();
    return {};
  }
}
function getRuntimeConfig() {
  try {
    const runtimeConfig = getData("runtime-config");
    logger2.debug("Runtime config was fetched from meta tag.", runtimeConfig)();
    return runtimeConfig;
  } catch (error) {
    logger2.debug("Runtime config could not be fetched from meta tag.", error)();
    return {};
  }
}

// src/utils/slugify.ts
function slugify(str) {
  return String(str).normalize("NFKD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-");
}

// src/utils/textHighlight.ts
function highlightMatch(text, searchTerm) {
  if (!searchTerm || !text) return [text];
  const term = searchTerm.trim().toLowerCase();
  if (!term) return [text];
  const tokens = Array.from(new Set(term.split(/\s+/).filter(Boolean)));
  if (!tokens.length) return [text];
  tokens.sort((a, b) => b.length - a.length);
  const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const pattern = tokens.map(escapeRegExp).join("|");
  const re = new RegExp(`(${pattern})`, "gi");
  const list = [];
  let prevIdx = 0;
  for (const match of text.matchAll(re)) {
    const idx = match.index ?? 0;
    const matched = match[0];
    if (idx > prevIdx) {
      const between = text.substring(prevIdx, idx);
      if (between.length > 0) list.push(between);
    }
    list.push({ highlight: matched });
    prevIdx = idx + matched.length;
  }
  if (prevIdx < text.length) {
    const tail = text.substring(prevIdx);
    if (tail.length > 0) list.push(tail);
  }
  return list.length ? list : [text];
}
function unhighlightMatch(segments) {
  return segments.map((segment) => typeof segment === "string" ? segment : segment.highlight).join("");
}

// src/utils/typeHelpers.ts
import { AssertionError } from "assertion-error";
function ensureNoNullsAndUndefineds(items) {
  return items.filter((x) => x !== null && x !== void 0);
}
function assertNonNullable(val) {
  if (val === null) {
    throw new AssertionError(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      `Expected 'val' to not be nullable, but received ${val}`
    );
  }
}
function assertIsDefined(val, variableName) {
  if (val === void 0 || val === null) {
    throw new AssertionError(`Expected ${variableName} to be defined, but received ${val}`);
  }
}
var filterNullables = (item) => item !== null && item !== void 0;
var extractNodeAsArray = (edge) => edge.node ? [edge.node] : [];
function isStringRecord(obj) {
  if (obj === null) return false;
  if (typeof obj !== "object") return false;
  if (Array.isArray(obj)) return false;
  if (Object.getOwnPropertySymbols(obj).length > 0) return false;
  return Object.getOwnPropertyNames(obj).every(
    (prop) => typeof prop === "string" && typeof obj[prop] === "string"
  );
}

// src/utils/useNow.ts
import { onScopeDispose, ref } from "vue";
var nowRef = ref(/* @__PURE__ */ new Date());
var subscribers = 0;
var timer;
function scheduleNextTick() {
  const msUntilNextMinute = 6e4 - Date.now() % 6e4;
  timer = setTimeout(() => {
    nowRef.value = /* @__PURE__ */ new Date();
    scheduleNextTick();
  }, msUntilNextMinute);
}
function useNow() {
  subscribers += 1;
  if (subscribers === 1) {
    nowRef.value = /* @__PURE__ */ new Date();
    scheduleNextTick();
  }
  onScopeDispose(() => {
    subscribers -= 1;
    if (subscribers === 0 && timer) {
      clearTimeout(timer);
      timer = void 0;
    }
  });
  return nowRef;
}

// ../../common/temp/node_modules/.pnpm/@vueuse+shared@13.3.0_vue@3.5.22_typescript@5.8.3_/node_modules/@vueuse/shared/index.mjs
import { shallowRef, watchEffect, readonly, watch, customRef, getCurrentScope, onScopeDispose as onScopeDispose2, effectScope, getCurrentInstance, hasInjectionContext, inject, provide, ref as ref2, isRef, unref, toValue as toValue$1, computed, reactive, toRefs as toRefs$1, toRef as toRef$1, shallowReadonly, onBeforeMount, nextTick, onBeforeUnmount, onMounted, onUnmounted, isReactive } from "vue";
function tryOnScopeDispose(fn) {
  if (getCurrentScope()) {
    onScopeDispose2(fn);
    return true;
  }
  return false;
}
var localProvidedStateMap = /* @__PURE__ */ new WeakMap();
var injectLocal = (...args) => {
  var _a;
  const key = args[0];
  const instance = (_a = getCurrentInstance()) == null ? void 0 : _a.proxy;
  if (instance == null && !hasInjectionContext())
    throw new Error("injectLocal must be called in setup");
  if (instance && localProvidedStateMap.has(instance) && key in localProvidedStateMap.get(instance))
    return localProvidedStateMap.get(instance)[key];
  return inject(...args);
};
var isClient = typeof window !== "undefined" && typeof document !== "undefined";
var isWorker = typeof WorkerGlobalScope !== "undefined" && globalThis instanceof WorkerGlobalScope;
var toString = Object.prototype.toString;
var isObject = (val) => toString.call(val) === "[object Object]";
function increaseWithUnit(target, delta) {
  var _a;
  if (typeof target === "number")
    return target + delta;
  const value = ((_a = target.match(/^-?\d+\.?\d*/)) == null ? void 0 : _a[0]) || "";
  const unit = target.slice(value.length);
  const result = Number.parseFloat(value) + delta;
  if (Number.isNaN(result))
    return target;
  return result + unit;
}
function pxValue(px) {
  return px.endsWith("rem") ? Number.parseFloat(px) * 16 : Number.parseFloat(px);
}
function toArray(value) {
  return Array.isArray(value) ? value : [value];
}
function cacheStringFunction(fn) {
  const cache = /* @__PURE__ */ Object.create(null);
  return (str) => {
    const hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
}
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cacheStringFunction((str) => str.replace(hyphenateRE, "-$1").toLowerCase());
var camelizeRE = /-(\w)/g;
var camelize = cacheStringFunction((str) => {
  return str.replace(camelizeRE, (_, c) => c ? c.toUpperCase() : "");
});
function getLifeCycleTarget(target) {
  return target || getCurrentInstance();
}
function tryOnMounted(fn, sync = true, target) {
  const instance = getLifeCycleTarget(target);
  if (instance)
    onMounted(fn, target);
  else if (sync)
    fn();
  else
    nextTick(fn);
}
function watchImmediate(source, cb, options) {
  return watch(
    source,
    cb,
    {
      ...options,
      immediate: true
    }
  );
}

// ../../common/temp/node_modules/.pnpm/@vueuse+core@13.3.0_vue@3.5.22_typescript@5.8.3_/node_modules/@vueuse/core/index.mjs
import { isRef as isRef2, shallowRef as shallowRef2, ref as ref3, watchEffect as watchEffect2, computed as computed2, inject as inject2, defineComponent, h, TransitionGroup, Fragment, shallowReactive, toValue, unref as unref2, getCurrentInstance as getCurrentInstance2, onMounted as onMounted2, watch as watch2, customRef as customRef2, onUpdated, readonly as readonly2, reactive as reactive2, hasInjectionContext as hasInjectionContext2, toRaw, nextTick as nextTick2, markRaw, getCurrentScope as getCurrentScope2, isReadonly, onBeforeUpdate } from "vue";
var defaultWindow = isClient ? window : void 0;
var defaultDocument = isClient ? window.document : void 0;
var defaultNavigator = isClient ? window.navigator : void 0;
var defaultLocation = isClient ? window.location : void 0;
function unrefElement(elRef) {
  var _a;
  const plain = toValue(elRef);
  return (_a = plain == null ? void 0 : plain.$el) != null ? _a : plain;
}
function useEventListener(...args) {
  const cleanups = [];
  const cleanup = () => {
    cleanups.forEach((fn) => fn());
    cleanups.length = 0;
  };
  const register = (el, event, listener, options) => {
    el.addEventListener(event, listener, options);
    return () => el.removeEventListener(event, listener, options);
  };
  const firstParamTargets = computed2(() => {
    const test = toArray(toValue(args[0])).filter((e) => e != null);
    return test.every((e) => typeof e !== "string") ? test : void 0;
  });
  const stopWatch = watchImmediate(
    () => {
      var _a, _b;
      return [
        (_b = (_a = firstParamTargets.value) == null ? void 0 : _a.map((e) => unrefElement(e))) != null ? _b : [defaultWindow].filter((e) => e != null),
        toArray(toValue(firstParamTargets.value ? args[1] : args[0])),
        toArray(unref2(firstParamTargets.value ? args[2] : args[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        toValue(firstParamTargets.value ? args[3] : args[2])
      ];
    },
    ([raw_targets, raw_events, raw_listeners, raw_options]) => {
      cleanup();
      if (!(raw_targets == null ? void 0 : raw_targets.length) || !(raw_events == null ? void 0 : raw_events.length) || !(raw_listeners == null ? void 0 : raw_listeners.length))
        return;
      const optionsClone = isObject(raw_options) ? { ...raw_options } : raw_options;
      cleanups.push(
        ...raw_targets.flatMap(
          (el) => raw_events.flatMap(
            (event) => raw_listeners.map((listener) => register(el, event, listener, optionsClone))
          )
        )
      );
    },
    { flush: "post" }
  );
  const stop = () => {
    stopWatch();
    cleanup();
  };
  tryOnScopeDispose(cleanup);
  return stop;
}
function useMounted() {
  const isMounted = shallowRef2(false);
  const instance = getCurrentInstance2();
  if (instance) {
    onMounted2(() => {
      isMounted.value = true;
    }, instance);
  }
  return isMounted;
}
function useSupported(callback) {
  const isMounted = useMounted();
  return computed2(() => {
    isMounted.value;
    return Boolean(callback());
  });
}
var ssrWidthSymbol = Symbol("vueuse-ssr-width");
function useSSRWidth() {
  const ssrWidth = hasInjectionContext2() ? injectLocal(ssrWidthSymbol, null) : null;
  return typeof ssrWidth === "number" ? ssrWidth : void 0;
}
function useMediaQuery(query, options = {}) {
  const { window: window2 = defaultWindow, ssrWidth = useSSRWidth() } = options;
  const isSupported = useSupported(() => window2 && "matchMedia" in window2 && typeof window2.matchMedia === "function");
  const ssrSupport = shallowRef2(typeof ssrWidth === "number");
  const mediaQuery = shallowRef2();
  const matches = shallowRef2(false);
  const handler = (event) => {
    matches.value = event.matches;
  };
  watchEffect2(() => {
    if (ssrSupport.value) {
      ssrSupport.value = !isSupported.value;
      const queryStrings = toValue(query).split(",");
      matches.value = queryStrings.some((queryString) => {
        const not = queryString.includes("not all");
        const minWidth = queryString.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        const maxWidth = queryString.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let res = Boolean(minWidth || maxWidth);
        if (minWidth && res) {
          res = ssrWidth >= pxValue(minWidth[1]);
        }
        if (maxWidth && res) {
          res = ssrWidth <= pxValue(maxWidth[1]);
        }
        return not ? !res : res;
      });
      return;
    }
    if (!isSupported.value)
      return;
    mediaQuery.value = window2.matchMedia(toValue(query));
    matches.value = mediaQuery.value.matches;
  });
  useEventListener(mediaQuery, "change", handler, { passive: true });
  return computed2(() => matches.value);
}
function useBreakpoints(breakpoints, options = {}) {
  function getValue(k, delta) {
    let v = toValue(breakpoints[toValue(k)]);
    if (delta != null)
      v = increaseWithUnit(v, delta);
    if (typeof v === "number")
      v = `${v}px`;
    return v;
  }
  const { window: window2 = defaultWindow, strategy = "min-width", ssrWidth = useSSRWidth() } = options;
  const ssrSupport = typeof ssrWidth === "number";
  const mounted = ssrSupport ? shallowRef2(false) : { value: true };
  if (ssrSupport) {
    tryOnMounted(() => mounted.value = !!window2);
  }
  function match(query, size) {
    if (!mounted.value && ssrSupport) {
      return query === "min" ? ssrWidth >= pxValue(size) : ssrWidth <= pxValue(size);
    }
    if (!window2)
      return false;
    return window2.matchMedia(`(${query}-width: ${size})`).matches;
  }
  const greaterOrEqual = (k) => {
    return useMediaQuery(() => `(min-width: ${getValue(k)})`, options);
  };
  const smallerOrEqual = (k) => {
    return useMediaQuery(() => `(max-width: ${getValue(k)})`, options);
  };
  const shortcutMethods = Object.keys(breakpoints).reduce((shortcuts, k) => {
    Object.defineProperty(shortcuts, k, {
      get: () => strategy === "min-width" ? greaterOrEqual(k) : smallerOrEqual(k),
      enumerable: true,
      configurable: true
    });
    return shortcuts;
  }, {});
  function current() {
    const points = Object.keys(breakpoints).map((k) => [k, shortcutMethods[k], pxValue(getValue(k))]).sort((a, b) => a[2] - b[2]);
    return computed2(() => points.filter(([, v]) => v.value).map(([k]) => k));
  }
  return Object.assign(shortcutMethods, {
    greaterOrEqual,
    smallerOrEqual,
    greater(k) {
      return useMediaQuery(() => `(min-width: ${getValue(k, 0.1)})`, options);
    },
    smaller(k) {
      return useMediaQuery(() => `(max-width: ${getValue(k, -0.1)})`, options);
    },
    between(a, b) {
      return useMediaQuery(() => `(min-width: ${getValue(a)}) and (max-width: ${getValue(b, -0.1)})`, options);
    },
    isGreater(k) {
      return match("min", getValue(k, 0.1));
    },
    isGreaterOrEqual(k) {
      return match("min", getValue(k));
    },
    isSmaller(k) {
      return match("max", getValue(k, -0.1));
    },
    isSmallerOrEqual(k) {
      return match("max", getValue(k));
    },
    isInBetween(a, b) {
      return match("min", getValue(a)) && match("max", getValue(b, -0.1));
    },
    current,
    active() {
      const bps = current();
      return computed2(() => bps.value.length === 0 ? "" : bps.value.at(strategy === "min-width" ? -1 : 0));
    }
  });
}
var DEFAULT_UNITS = [
  { max: 6e4, value: 1e3, name: "second" },
  { max: 276e4, value: 6e4, name: "minute" },
  { max: 72e6, value: 36e5, name: "hour" },
  { max: 5184e5, value: 864e5, name: "day" },
  { max: 24192e5, value: 6048e5, name: "week" },
  { max: 28512e6, value: 2592e6, name: "month" },
  { max: Number.POSITIVE_INFINITY, value: 31536e6, name: "year" }
];

// src/utils/useScaBreakpoints.ts
import { computed as computed3 } from "vue";
var screens = {
  /** Small mobile devices: 440px and up */
  sm: "440px",
  /** Large mobile devices: 600px and up */
  md: "600px",
  /** Small tablets: 760px and up */
  lg: "760px",
  /** Large tablets/small desktops: 1024px and up */
  xl: "1024px",
  /** Large desktops: 1400px and up */
  "2xl": "1400px"
};
var useScaBreakpoints_default = () => {
  const breakpoints = useBreakpoints(screens);
  const currentDevice = computed3(
    () => breakpoints.greaterOrEqual("2xl").value ? "DESKTOP" /* DESKTOP */ : breakpoints.between("lg", "2xl").value ? "TABLET" /* TABLET */ : "MOBILE" /* MOBILE */
  );
  const isDesktop = computed3(() => currentDevice.value === "DESKTOP" /* DESKTOP */);
  const isAtLeastXL = computed3(() => breakpoints.greaterOrEqual("xl").value);
  const isTablet = computed3(() => currentDevice.value === "TABLET" /* TABLET */);
  const isMobile = computed3(() => currentDevice.value === "MOBILE" /* MOBILE */);
  return {
    /** VueUse breakpoints instance for fine-grained breakpoint control */
    breakpoints,
    /** Reactive device category (DESKTOP, TABLET, or MOBILE) */
    currentDevice,
    /** Reactive boolean for desktop detection */
    isDesktop,
    /** Reactive boolean for XL+ screen detection */
    isAtLeastXL,
    /** Reactive boolean for tablet detection */
    isTablet,
    /** Reactive boolean for mobile detection */
    isMobile
  };
};

// src/utils/vuelidate.ts
import * as validators from "@vuelidate/validators";
import { helpers as helpers2 } from "@vuelidate/validators";
import { unref as unref3 } from "vue";
var defineRules = (rules) => {
  return rules;
};
var required2 = helpers2.withMessage(() => $t("common.validation.empty"), validators.required);
var url2 = helpers2.withMessage(() => $t("common.label.fieldNeedsValid"), validators.url);
var email2 = helpers2.withMessage(() => $t("common.label.fieldNeedsValid2"), validators.email);
var requiredIf2 = (predicate) => validators.helpers.withMessage(() => $t("common.validation.fieldRequired"), validators.requiredIf(predicate));
var minLength2 = (min) => validators.helpers.withMessage(
  (props) => $t("common.validation.containLeast", {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    length: props.$params.min.toString()
  }),
  validators.minLength(min)
);
var getErrors = (field) => {
  if (field.$error) {
    return field.$errors.map((e) => unref3(e.$message));
  }
  return [];
};

// src/config/index.ts
var logger3 = useLogger("core/config");
var dynamicRuntimeConfig = getRuntimeConfig();
var defaultBaseConfig = {
  NODE_ENV: "development",
  VITE_APP_URL: "http://localhost:8080"
};
var baseConfig = {
  nodeEnv: getString("NODE_ENV", defaultBaseConfig),
  appUrl: getString("VITE_APP_URL", defaultBaseConfig),
  scaylaApiUrl: getString("VITE_APP_SCAYLA_API_URL", defaultBaseConfig, true)
};
logger3.debug("baseConfig", baseConfig)();
var defaultAuthConfig = {
  VITE_APP_OIDC_CLIENT_ID: void 0,
  VITE_APP_OIDC_AUTHORITY: void 0
};
var rawAuthConfig = {
  VITE_APP_OIDC_CLIENT_ID: getString("VITE_APP_OIDC_CLIENT_ID", defaultAuthConfig, true),
  VITE_APP_OIDC_AUTHORITY: getString("VITE_APP_OIDC_AUTHORITY", defaultAuthConfig, true)
};
assertIsDefined(rawAuthConfig.VITE_APP_OIDC_CLIENT_ID, "rawAuthConfig.VITE_APP_OIDC_CLIENT_ID");
assertIsDefined(rawAuthConfig.VITE_APP_OIDC_AUTHORITY, "rawAuthConfig.VITE_APP_OIDC_AUTHORITY");
var authConfig = {
  oidcClientId: rawAuthConfig.VITE_APP_OIDC_CLIENT_ID,
  oidcAuthority: rawAuthConfig.VITE_APP_OIDC_AUTHORITY
};
logger3.debug("authConfig", authConfig)();
var defaultSentryConfig = {
  VITE_APP_SENTRY_ENABLED: "false"
};
var rawSentryConfig = {
  VITE_APP_SENTRY_ENABLED: getBool("VITE_APP_SENTRY_ENABLED", defaultSentryConfig, true),
  VITE_APP_SENTRY_DSN: getString("VITE_APP_SENTRY_DSN", defaultSentryConfig),
  VITE_APP_SENTRY_ENVIRONMENT: getString("VITE_APP_SENTRY_ENVIRONMENT", defaultSentryConfig),
  VITE_APP_SENTRY_PROJECT_NAME: getString("VITE_APP_SENTRY_PROJECT_NAME", defaultSentryConfig),
  VITE_APP_SENTRY_VERSION: getString("VITE_APP_SENTRY_VERSION", defaultSentryConfig)
};
assertIsDefined(rawSentryConfig.VITE_APP_SENTRY_ENABLED, "rawSentryConfig.VITE_APP_SENTRY_ENABLED");
if (rawSentryConfig.VITE_APP_SENTRY_ENABLED === true) {
  assertIsDefined(rawSentryConfig.VITE_APP_SENTRY_DSN, "VITE_APP_SENTRY_DSN");
  assertIsDefined(rawSentryConfig.VITE_APP_SENTRY_ENVIRONMENT, "VITE_APP_SENTRY_ENVIRONMENT");
  assertIsDefined(rawSentryConfig.VITE_APP_SENTRY_PROJECT_NAME, "VITE_APP_SENTRY_PROJECT_NAME");
  assertIsDefined(rawSentryConfig.VITE_APP_SENTRY_VERSION, "VITE_APP_SENTRY_VERSION");
}
var sentryConfig = {
  enabled: rawSentryConfig.VITE_APP_SENTRY_ENABLED,
  dsn: rawSentryConfig.VITE_APP_SENTRY_DSN,
  projectName: rawSentryConfig.VITE_APP_SENTRY_PROJECT_NAME,
  env: rawSentryConfig.VITE_APP_SENTRY_ENVIRONMENT,
  version: rawSentryConfig.VITE_APP_SENTRY_VERSION
};
logger3.debug("sentryConfig", sentryConfig)();
var defaultEmailFeatureConfig = {
  VITE_APP_SHOW_EMAIL_FEATURE: "false"
};
var rawEmailFeatureConfig = {
  VITE_APP_SHOW_EMAIL_FEATURE: getBool("VITE_APP_SHOW_EMAIL_FEATURE", defaultEmailFeatureConfig, false)
};
var emailFeatureConfig = {
  enabled: rawEmailFeatureConfig.VITE_APP_SHOW_EMAIL_FEATURE
};
logger3.debug("emailFeatureConfig", rawEmailFeatureConfig)();
var agGridlicenseKeyDefault = {
  VITE_APP_AG_GRID_LICENSE: ""
};
var rawAgGridlicenseKey = {
  VITE_APP_AG_GRID_LICENSE: getString("VITE_APP_AG_GRID_LICENSE", agGridlicenseKeyDefault)
};
assertIsDefined(rawAgGridlicenseKey.VITE_APP_AG_GRID_LICENSE, "rawAgGridlicenseKey.VITE_APP_AG_GRID_LICENSE");
var agGridFeatureConfig = {
  licenseKey: rawAgGridlicenseKey.VITE_APP_AG_GRID_LICENSE
};
var tinyMCEApiKeyDefault = {
  VITE_APP_TINY_MCE_API_KEY: ""
};
var rawTinyMCEApiKey = {
  VITE_APP_TINY_MCE_API_KEY: getString("VITE_APP_TINY_MCE_API_KEY", tinyMCEApiKeyDefault)
};
var tinyMCEFeatureConfig = {
  apiKey: rawTinyMCEApiKey.VITE_APP_TINY_MCE_API_KEY
};
function getString(key, defaultConfig, required3 = false) {
  if (typeof key === "number") return void 0;
  let value;
  if (defaultConfig[key] !== void 0) {
    logger3.debug("Checking for key in defaultConfig: ", key, defaultConfig[key]);
    value = String(defaultConfig[key]);
  }
  if (import.meta.env[key] !== void 0) {
    logger3.debug("Checking for key in import.meta.env: ", key, import.meta.env[key]);
    value = String(import.meta.env[key]);
  }
  if (dynamicRuntimeConfig[key] !== void 0) {
    logger3.debug("Checking for key in dynamicRuntimeConfig: ", key, dynamicRuntimeConfig[key]);
    value = String(dynamicRuntimeConfig[key]);
  }
  if (required3) {
    assertIsDefined(value, key);
    if (!value) {
      throw new Error(`Missing required value for config variable "${key}"`);
    }
  }
  return value;
}
function getBool(key, defaultConfig, required3 = false) {
  if (typeof key === "number") return void 0;
  const val = getString(key, defaultConfig, required3);
  let value;
  if (typeof val === "string") {
    value = val.toLowerCase() === "true";
  }
  if (required3) {
    assertIsDefined(value, key);
    if (!value && typeof value !== "boolean") {
      throw new Error(`Missing required value for config variable "${key}"`);
    }
  }
  if (typeof value !== "boolean" && required3) {
    throw new Error(
      `Value for config variable "${key}" is required and expected to be a boolean or a string, is "${typeof value}"`
    );
  }
  return value;
}

// src/oidc.ts
import { unref as unref4 } from "vue";
import { useOidcStore, WebStorageStateStore } from "vue3-oidc";
import { createOidc, useAuth, useOidcStore as useOidcStore2 } from "vue3-oidc";
var appUrl = baseConfig.appUrl ?? "";
var logger4 = useLogger("core/oidc");
var { state } = useOidcStore();
var redirect_uri = new URL("/oidc-callback", appUrl).toString();
var silent_redirect_uri = new URL("/silent-renew.html", appUrl).toString();
var post_logout_redirect_uri = new URL("/sign-out", appUrl).toString();
var oidcSettings = {
  /** OIDC authority/issuer URL (configured via environment variables) */
  authority: authConfig.oidcAuthority,
  /** OAuth2 scopes requested during authentication */
  scope: "openid email profile offline_access",
  /** OIDC client identifier (configured via environment variables) */
  client_id: authConfig.oidcClientId,
  /** Main authentication callback URI */
  redirect_uri,
  /** Silent token renewal URI */
  silent_redirect_uri,
  /** Post-logout redirect URI */
  post_logout_redirect_uri,
  /** OAuth2 response type (Authorization Code flow) */
  response_type: "code",
  /** Whether to load user profile information from the UserInfo endpoint */
  loadUserInfo: true,
  /** Enable automatic silent token renewal */
  automaticSilentRenew: true,
  /** Monitor session state for changes */
  monitorSession: true,
  /** Validate subject claim during silent renewal for security */
  validateSubOnSilentRenew: true,
  userStore: typeof window !== "undefined" ? new WebStorageStateStore({ store: window.localStorage }) : void 0,
  /**
   * Callback function executed after successful sign-in redirect
   *
   * Handles post-authentication redirection, either to the originally requested
   * page (stored in state.redirect_uri) or to the application root.
   *
   * @param user - User object returned from successful authentication
   */
  onSigninRedirectCallback(user) {
    logger4.log("User authenticated successfully", user)();
    location.href = unref4(state).redirect_uri || "/";
  }
};

// src/sentry/index.ts
import * as Sentry from "@sentry/vue";
var useSentry = (app, router) => {
  if (sentryConfig.enabled) {
    Sentry.init({
      /** Vue app instance for integration */
      app,
      /** Enable/disable Sentry based on configuration */
      enabled: sentryConfig.enabled,
      /** Sentry Data Source Name (DSN) for error reporting */
      dsn: sentryConfig.dsn,
      /** Environment identifier (e.g., 'production', 'staging') */
      environment: sentryConfig.env,
      /** Release identifier combining project name and version */
      release: `${sentryConfig.projectName}/${sentryConfig.version ?? ""}`,
      /**
       * Sentry integrations for comprehensive monitoring
       */
      integrations: [
        /**
         * Vue.js integration for component error tracking and performance monitoring
         * - Captures Vue component errors automatically
         * - Attaches component props for debugging context
         * - Tracks component lifecycle performance
         */
        Sentry.vueIntegration({
          attachErrorHandler: true,
          attachProps: true,
          tracingOptions: {
            trackComponents: true
          },
          app
        }),
        /** Browser session tracking for user behavior analysis */
        Sentry.browserSessionIntegration(),
        /** Browser API error detection (fetch, XMLHttpRequest, etc.) */
        Sentry.browserApiErrorsIntegration(),
        /** Vue Router navigation performance tracking */
        Sentry.browserTracingIntegration({ router }),
        /** Session replay for visual debugging of user interactions */
        Sentry.replayIntegration()
      ],
      /**
       * Performance monitoring sample rate (10% of transactions)
       * Balances monitoring coverage with performance impact
       */
      tracesSampleRate: 0.1,
      /** Attach Vue component props to error reports for debugging */
      attachProps: true,
      /**
       * Profiling sample rate (10% of transactions)
       * Provides detailed performance profiling data
       */
      profilesSampleRate: 0.1,
      /**
       * URLs for which trace propagation should be enabled
       * Allows distributed tracing across services
       */
      tracePropagationTargets: ["localhost", /^\/scayla/],
      /**
       * Session replay sample rate for normal sessions (10%)
       * Records user sessions for debugging purposes
       */
      replaysSessionSampleRate: 0.1,
      /**
       * Session replay sample rate for error sessions (10%)
       * Always record sessions that encounter errors
       */
      replaysOnErrorSampleRate: 0.1
    });
  }
};
export {
  $t,
  Sentry,
  agGridFeatureConfig,
  applyDatePrecision,
  applyTimePrecision,
  assertIsDefined,
  assertNonNullable,
  authConfig,
  baseConfig,
  convertNameToInitials,
  createOidc,
  createScaylaI18n,
  defineRules,
  email2 as email,
  emailFeatureConfig,
  ensureNoNullsAndUndefineds,
  extractNodeAsArray,
  fileExtensionFromFileType,
  fileExtensionToIconMapping,
  filterNullables,
  formatBytes,
  formatDate,
  formatDateTime,
  formatTime,
  formatWithLocale,
  getAllFilesFromDataTransfer,
  getCountryNames,
  getCountryOptions,
  getData,
  getErrors,
  getLocale,
  getRuntimeConfig,
  handleError,
  highlightMatch,
  isStringRecord,
  mimeTypeToIconMapping,
  minLength2 as minLength,
  oidcSettings,
  parseDate,
  required2 as required,
  requiredIf2 as requiredIf,
  resolveDateFnsLocale,
  sentryConfig,
  setLocale,
  slugify,
  tinyMCEFeatureConfig,
  unhighlightMatch,
  url2 as url,
  useAuth,
  useErrorService,
  useLogger,
  useNow,
  useOidcStore2 as useOidcStore,
  useScaBreakpoints_default as useScaBreakpoints,
  useSentry
};
//# sourceMappingURL=index.js.map